<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="payment?.payer_name"
      [canGoBack]="!windowService.isDesktopRes" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded && payment) {

      <!-- ===== Invoice ===== -->
      <tidy-card>
        <tidy-row [alignLastItemRight]="true">
          <tidy-text [title]="payment.description" [translate]="false" />
          <tidy-text [body]="payment.status" [translate]="false" [ngStyle]="{ color: statusColorValue }" />
        </tidy-row>
        <div style="position: absolute; left: 0; right: 0; height: 7px; background: #275C7C;"></div>
        <tidy-row class="extra-top-padding" [alignLastItemRight]="true">
          <tidy-text [body]="'Charge'" />
          <tidy-text [body]="'Amount'" />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-divider />
        </tidy-row>
        <tidy-row [alignLastItemRight]="true">
          <div style="width: 85%">
            <tidy-text [header]="payment.description" [translate]="false" />
          </div>
          <div>
            <tidy-text [body]="'$' + payment.amount.toLocaleString('en-US')" [translate]="false" />
          </div>
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="propertyLabel + '  ·  ' + (payment.status === 'Paid' ? 'paid ' : 'due ') + ((payment.status === 'Paid' ? payment.paid_date : payment.due_date) | date:'MMM d, yyyy')"
            [translate]="false" />
        </tidy-row>
        @if (payment.status === 'Paid' && payment.method) {
          <tidy-row class="extra-top-padding" [alignLastItemRight]="true">
            <tidy-text [body]="'Processing fee (' + (payment.fee_paid_by === 'tenant' ? 'paid by payer' : 'absorbed by you') + ')'" [translate]="false" />
            <tidy-text [body]="'$' + payment.fee.toFixed(2)" [translate]="false" />
          </tidy-row>
        }
        <tidy-row class="extra-top-padding extra-bottom-padding">
          <tidy-divider />
        </tidy-row>
        <tidy-row [alignLastItemRight]="true">
          <tidy-text [header]="'Total'" />
          <tidy-text [body]="('<b>$' | translate) + tenantPays.toLocaleString('en-US') + '</b>'" [translate]="false" />
        </tidy-row>
        @if (payment.status !== 'Paid') {
          <tidy-row>
            <tidy-text [helper]="('Final fee depends on the method the payer chooses (ACH ~$5, card 2.9% + 30¢). Fee is currently set to be paid by the ' | translate) + (payment.fee_paid_by === 'tenant' ? 'payer' : 'owner') + '.'" />
          </tidy-row>
        }
        @if (payment.status === 'Paid') {
          <tidy-row [alignLastItemRight]="true">
            <tidy-text [body]="'Paid with'" />
            <tidy-text [body]="payment.method || 'Outside TIDY (cash / check)'" [translate]="false" />
          </tidy-row>
          <tidy-row [alignLastItemRight]="true">
            <tidy-text [body]="'You received'" />
            <tidy-text [body]="'$' + ownerReceives.toLocaleString('en-US')" [translate]="false" />
          </tidy-row>
          @if (payment.payout_status) {
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="'Payout'" />
              <tidy-text [body]="payment.payout_status" [translate]="false" />
            </tidy-row>
          }
        }

        <!-- Actions on this bill -->
        @if (payment.status !== 'Paid') {
          <tidy-card-button (action)="copyAction()">
            <tidy-row class="vertical-align-center">
              <tidy-image [src]="'assets/img/link-green.svg'" class="body-size" />
              <tidy-text [body]="'Copy Payment Link'" />
            </tidy-row>
          </tidy-card-button>
          <tidy-card-button (action)="sendAction()">
            <tidy-row class="vertical-align-center">
              <tidy-image [src]="'assets/img/message.svg'" class="body-size" />
              <tidy-text [body]="'Send via Messages'" />
            </tidy-row>
          </tidy-card-button>
          @if (payment.status === 'Due' || payment.status === 'Overdue') {
            <tidy-card-button (action)="remindAction()">
              <tidy-row class="vertical-align-center">
                <tidy-image [src]="'assets/img/bell.svg'" class="body-size" />
                <tidy-text [body]="'Send a Reminder Now'" />
              </tidy-row>
            </tidy-card-button>
          }
          <tidy-card-button (action)="previewAction()">
            <tidy-row class="vertical-align-center">
              <tidy-image [src]="'assets/img/credit-card.svg'" class="body-size" />
              <tidy-text [body]="'Open Payment Page'" />
            </tidy-row>
          </tidy-card-button>
          <tidy-card-button (action)="recordOfflineAction()">
            <tidy-row class="vertical-align-center">
              <tidy-image [src]="'assets/img/dollar.svg'" class="body-size" />
              <tidy-text [body]="'Record Payment Made Outside TIDY'" />
            </tidy-row>
          </tidy-card-button>
        }
        @if (payment.status === 'Paid') {
          <tidy-card-button (action)="previewAction()">
            <tidy-row class="vertical-align-center">
              <tidy-image [src]="'assets/img/credit-card.svg'" class="body-size" />
              <tidy-text [body]="'View Payment Page'" />
            </tidy-row>
          </tidy-card-button>
        }
      </tidy-card>

      <!-- ===== Details ===== -->
      <tidy-row><tidy-text [title]="'Details'" /></tidy-row>
      <tidy-card>
        <tidy-row [alignLastItemRight]="true">
          <tidy-text [body]="'Payer'" />
          <tidy-text [body]="payment.payer_name + ' (' + payment.payer_type + ')'" [translate]="false" />
        </tidy-row>
        <tidy-row [alignLastItemRight]="true">
          <tidy-text [body]="'Property'" />
          <tidy-text [body]="propertyLabel" [translate]="false" />
        </tidy-row>
        @if (leaseLabel) {
          <tidy-row>
            <tidy-text [actionBody]="leaseLabel" [translate]="false" (action)="goToLeaseAction()" class="white-link" />
          </tidy-row>
        }
        @if (cadenceLabel) {
          <tidy-row [alignLastItemRight]="true">
            <tidy-text [body]="'Cadence'" />
            <tidy-text [body]="cadenceLabel" [translate]="false" />
          </tidy-row>
        }
        <tidy-row [alignLastItemRight]="true">
          <tidy-text [body]="'Source'" />
          <tidy-text [body]="payment.source === 'Recurring' ? 'Recurring rent' : 'Manual request'" [translate]="false" />
        </tidy-row>
        @if (payment.status !== 'Paid') {
          <tidy-row class="extra-top-padding extra-bottom-padding">
            <tidy-divider />
          </tidy-row>
          <tidy-row>
            <tidy-text [helper]="'A secure, standalone payment link just for this payment. Copy it and send it however you like.'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="payLink" [translate]="false" class="white-link" [ngStyle]="{ 'word-break': 'break-all' }" />
          </tidy-row>
        }
      </tidy-card>

      <!-- ===== Status timeline ===== -->
      <tidy-row><tidy-text [title]="'Activity'" /></tidy-row>
      <tidy-card>
        @for (event of payment.timeline; track $index) {
          <tidy-row class="vertical-align-center">
            <span [ngStyle]="{ 'width': '9px', 'height': '9px', 'border-radius': '50%', 'margin-right': '10px', 'flex-shrink': '0', 'background-color': event.done ? 'var(--primary-button, #4295a3)' : '#d0d0d0' }"></span>
            <tidy-text [body]="event.label" [translate]="false" [ngStyle]="event.done ? {} : { color: '#9a9a9a' }" />
            @if (event.date) {
              <tidy-text [helper]="'  ·  ' + (event.date | date:'MMM d')" [translate]="false" />
            }
          </tidy-row>
        }
      </tidy-card>
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
